export default __webpack_public_path__ + "static/media/coming-soon.a36dbc78.webp";